// The Charter for Accountable AI: seven principles, each linked to where the site argues for it
// or puts it to work, and the form to sign it.
import { ArrowRight } from "@phosphor-icons/react";
import { Link } from "react-router";

import { useCharter } from "../api/hooks";
import { CHARTER } from "../content/charter";
import { useTitle } from "../ui/hooks";
import { RedPen } from "../ui/RedPen";
import { SignForm } from "./charter/SignForm";

export function Charter() {
  useTitle("The Charter for Accountable AI");
  const charter = useCharter();
  return (
    <>
      <section className="grain border-b border-line">
        <div className="wrap py-14 sm:py-20">
          <p className="kicker">§ The Charter for Accountable AI · Draft 1</p>
          <h1 className="display mt-4 max-w-5xl text-[3rem] sm:text-[4.6rem] lg:text-[5.4rem]">
            Seven things we ask of every <RedPen kind="underline">AI company.</RedPen>
          </h1>
          <div className="mt-8 flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
            <p className="lede max-w-2xl">
              A bar set in public, by the people AI is meant to serve. It is a draft: argue with it, improve it, and sign it when it says what you believe.
            </p>
            <div className="flex items-center gap-5">
              {charter.data ? (
                <p className="font-mono text-sm text-ink2">
                  <span className="font-display text-4xl font-extrabold text-ink">{charter.data.signatures.toLocaleString("en-GB")}</span> signed
                </p>
              ) : null}
              <a href="#sign" className="btn-signal">
                Sign it
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="wrap py-10">
        <ol>
          {CHARTER.map((p) => (
            <li key={p.n} className="grid gap-4 border-b border-line py-10 last:border-0 md:grid-cols-[7rem_1fr_1.2fr] md:gap-10">
              <span className="font-display text-6xl font-extrabold leading-none text-signal">{String(p.n).padStart(2, "0")}</span>
              <h2 className="font-display text-3xl font-bold leading-tight tracking-[-0.025em]">{p.title}</h2>
              <div>
                <p className="font-serif text-[1.2rem] leading-relaxed text-ink2">{p.body}</p>
                <Link to={p.more.to} className="mt-4 inline-flex items-center gap-1.5 text-[14.5px] font-semibold hover:text-signal">
                  {p.more.label} <ArrowRight weight="bold" className="h-4 w-4" aria-hidden />
                </Link>
              </div>
            </li>
          ))}
        </ol>
      </section>
      <section id="sign" className="scroll-mt-20 border-t border-line bg-paper2/50">
        <div className="wrap grid gap-10 py-16 sm:py-20 lg:grid-cols-[1fr_1.4fr]">
          <div>
            <p className="kicker">§ Sign</p>
            <h2 className="h2 mt-3">Put your name to it.</h2>
            <p className="lede mt-4">Every signature makes the bar heavier. Organisations can sign too: say which one, and we'll count it.</p>
          </div>
          <SignForm />
        </div>
      </section>
    </>
  );
}
